export const HOST = 'https://launch.squidapps.co/';
